import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { NotificationsService } from '../services/notifications.service';

/**
 * This directive is used to show or hide DOM based on whether notifications for a given channel is available.
 * The checks will be based on the channels provided. Multiple channels can be passed in.
 * 
 * Example:
 * <div class="padding-bottom-10" *notificationsIf="['browser']">
 * 		<ac-notifications [channel]="['browser']"></ac-notifications>
 * </div>
 */
@UntilDestroy()
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[notificationsIf]'
})

export class NotificationsIfDirective implements OnInit {
	private _notificationsIf: string[];
	@Input() public set notificationsIf(channel: string[]) {
		this._notificationsIf = channel;
	}

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		private notificationsService: NotificationsService
	) { }

	public ngOnInit(): void {
		let isContentShown = false;
		this.viewContainerRef.clear();

		this.notificationsService.getAllNotifications$().pipe(
			untilDestroyed(this)
		).subscribe(notifications => {
			const activeBrowserNotification = notifications.filter(notification => this._notificationsIf.includes(notification.channel) && notification.isDismissed === false);

			if (activeBrowserNotification?.length > 0) {
				if (!isContentShown) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
					isContentShown = true;
				}
			} else {
				isContentShown = false;
				this.viewContainerRef.clear();
			}
		});
	}
}
